import $ from 'jquery';
import logEngagement from '../../modules/log-engagement';
import './size-selection-modal';
import { renderCartSocialProof } from "../../modules/social-proof";
import showQuickView from '../../modules/quick-view';
const ENGAGEMENT_MODULE = 'shopping_bag';
const WISHLIST_MARKUP_ENDPOINT = "/fw/content/wishlist/sliderMarkup";

function clickTracker(action, code) {
    logEngagement(
        window.location.href,
        "shopping_bag",
        action,
        { code: code }
    );
}

function setupViewShippingOptions(){
    $('#viewShippingMethods').click(function (e) {
        $.modal({
            url : '/fw/dialog/ShippingMethods.jsp',
            triggerOpen: true,
            type :'small',
            returnFocus:'#viewShippingMethods'
        })
    });
}

function showBagSyncNotifications(){
    if(!window.rcProps.shoppingBag.showBagNotification){
        return;
    }

    var data = $.param({
        notificationsHandled: true,
        fw: true
    });
    $.ajax({
        type: 'POST',
        url: '/r/ajax/GetBagSyncNotifications.jsp',
        data: data,
        success: function(rtn){
            var obj = JSON ? JSON.parse(rtn) : $.parseJSON(rtn);
            if (obj.success){
                var type = obj.msg4;
                var notificationModalId = '';
                if('new_customer' === type){
                    notificationModalId = 'save-shopping-bag-1';
                }else if('no_previous_items' === type){
                    notificationModalId = 'save-shopping-bag-2';
                }else if('return_customer' === type){
                    notificationModalId = 'save-shopping-bag-3';
                }else if('return_customer_checkout' === type){
                    notificationModalId = 'save-shopping-bag-4';
                }

                if(notificationModalId != ''){
                    $.modal({
                        open: notificationModalId,
                        triggerOpen: true,
                        type: 'notification',
                    });
                }
            }
        }
    });
}

$(function() {
    loadcarousels();
});

function loadcarousels() {
    $.ajax({
        type: 'GET',
        url: window.rcProps.shoppingBag.carouselsEndpoint,
        success: function (data) {
            var $carouselsWrapper = $("#carousels-wrapper-optimize").html(data);

            if (data.trim().length === 0) {
                $('#carousels-wrapper-optimize').addClass('u-hide');
                return;
            }

            reinitializeWishListCarousel();
            $(".remove_wish_list").click(removeWishListItem);
            $('.js-add-on').recsPopOut();
            // lazy loading for images for shopping bag and shopping bag carousels
            // needs to be removed
            $('.js-shopping-bag-lazy-img', $carouselsWrapper).lazy({
                bind: 'event',
                effect: 'fadeIn',
                effectTime: 500,
                threshold: 0
            });
        }
    });
}

function reloadShoppingBag(callback, removedItemIndex){
    let param="";
    if(typeof removedItemIndex !== "undefined" && removedItemIndex !== -1){
        param = "?removedItemIndex=" + removedItemIndex;
    }
    $('#js-bag-content').load("/fw/ajax/ShoppingBagContent.jsp" + param, function () {
        $(".js-modal").modal();
        if(typeof callback === 'function'){
            callback();
        }
        bindEvents();
        $('#js-bag-content').find('.vanish').vanish();
        setupViewShippingOptions();
        updateBagTotals();
        window.rcProps = window.rcProps || {};
        window.rcProps.shoppingBag = window.rcProps.shoppingBag || {};
        if (window.rcProps.shoppingBag.gotoPayPal === true) {
            if (typeof renderPayPal === 'function') {
                renderPayPal();
            }
        }
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
        window.KlarnaOnsiteService.push({eventName: 'refresh-placements'});
    })
}
function reinitializeWishListCarousel() {
    $('.js-carousel--seven').each(function () {
        const $this = $(this);
        $this.slickSlider({
            lazyLoad: 'progressive',
            slidesToShow: 7,
            slidesToScroll: 7,
            nextArrow: $this.children('.slick-next'),
            prevArrow: $this.children('.slick-prev'),
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6
                    }
                },
                {
                    breakpoint: 901,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5
                    }
                }
            ]
        });
    });
}
window.reloadWishListCarousel = function (callback, gridLayout){
    const layout = $("#wishlist-wrapper").data('layout');
    const data = $.param({
        gridLayout: layout === 'gridLayout'
    });
    $.ajax({
        type: 'GET',
        url: WISHLIST_MARKUP_ENDPOINT,
        data: data,
        cache: false, // required to prevent get cached markup from browser.
        success: function (rtn) {
            $("#wishlist-wrapper").empty().append(rtn);
            if ($("#wishlist-wrapper").find(".product-recs__copy").length == 0) {
                loadcarousels();
            }
            reinitializeWishListCarousel();
            $(".remove_wish_list").click(removeWishListItem);
            if(typeof callback === 'function'){
                callback()
            }
        }
    });
}


function removeWishListItem(event){
    (event.preventDefault) ? event.preventDefault() : event.returnValue = false;

    var data = {
        code: $(this).data('code'),
        size: $(this).data('size'),
    };
    $.modal({
        url: window.rcProps.shoppingBag.wishList.removalUrl,
        data: data,
        triggerOpen : true,
        type: 'small',
        returnFocus: $(event.target),
        onComplete : function(){
            if(typeof brazeAddToFavorites === 'function') {
                brazeAddToFavorites('remove',
                    $(this).data('code'),
                    $(this).data('name'),
                    $(this).data('size'),
                    $(this).data('imageurl'),
                    $(this).data('pdpurl'),
                    $(this).data('price'),
                    $(this).data('currency'),
                    $(this).data('department'),
                    $(this).data('color'),
                    $(this).data('brand'),
                    $(this).data('category'),
                    $(this).data('cat1'));
            }
        }
    });
}


function updateBag(productcode,size,totalval, sectionURL, name, brand, categoryName, price, currencyCode, previousTotal, restoreCallBack) {
    var total = totalval;

    var qtyToAdd = parseInt(total) - previousTotal;

    window.rcProps = window.rcProps || {};
    window.rcProps.ReCAPTCHACallBack = function(){
        window.rcProps.showReCAPTCHA = false;
        window.rcProps.maxLimit = 50;
        updateBag(productcode,size,totalval, sectionURL, name, brand, categoryName, price, currencyCode, previousTotal, restoreCallBack);
    };
    window.rcProps.ReCAPTCHARestore = function(){
        if(typeof restoreCallBack === 'function'){
            restoreCallBack();
        }
    }


    window.addProduct(productcode, size, sectionURL, null, qtyToAdd,
        function(obj){
            if (obj){
                if (obj.success){
                    reloadShoppingBag(function () {
                        $.modal({
                            open: "item-qty-update-modal",
                            triggerOpen: true,
                            type: "notification",
                        });
                    });
                }

            }
        });

}



function updateBagTotals() {
    $.ajax(
        {url:"/fw/ajax/CartItemCount.jsp",cache:false}
    ).done(function(msg){
        if (msg.bagCount) {
            $("#cart_item_count").text(msg.bagCount);
        }
    });
}

function openAddToBagNotificationModal(carouselType, $triggerTarget) {
    let modelId = 'wishlist-added-modal'; // By default, wish list.
    if (carouselType === 'recently_viewed') {
        modelId = 'recently-viewed-added-modal';
    } else if (carouselType === 'beauty_add_on') {
        modelId = "item-added-modal";
    }
    $.modal({
        open: modelId,
        triggerOpen: true,
        type: 'notification',
        returnFocus: $triggerTarget,
    })
}

function addToBagFromCarouselItem(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice, carouselType, department, cat1) {
    addToBagFromShoppingBag(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice,
        function () {
            if (carouselType !== undefined) {
                let logEngagementModule = '';
                if (carouselType === 'recently_viewed') {
                    logEngagementModule = 'recently_viewed';
                    loadcarousels();
                } else if (carouselType === 'beauty_add_on') {
                    logEngagementModule = 'beauty_add_on';
                }
                logEngagement(window.location.href, logEngagementModule, "move_to_bag");
                openAddToBagNotificationModal(carouselType);
            }
        }, '', carouselType, department, cat1);
}

function addToBagFromWishList(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice, department, cat1, fullPdpUrl, currency, color) {
    addToBagFromShoppingBag(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice,
        function () {
            logEngagement(window.location.href, "wish_list", "move_to_bag");
            $.modal({
                open: "wishlist-added-modal",
                triggerOpen: true,
                type: "notification",
            })
        }, '', 'wish_list', department, cat1, fullPdpUrl, currency, color);
}

function addToBagFromShoppingBag(code, size, name, brand, imageUrl, categoryName, brandName, pdpUrl, retailPrice, callback, dateAdded, carouselType, department, cat1, fullPdpUrl, currency, color) {
    addToBagFromShoppingBagWithObject({
        code: code,
        size: size,
        name: name,
        brand: brand,  // Seems redundant with `brandName` but leaving as-is since it's existing code
        imageUrl: imageUrl,
        categoryName: categoryName,
        brandName: brandName,
        pdpUrl: pdpUrl,
        retailPrice: retailPrice,
        callbacks: {
            success: callback,
        },
        dateAdded: dateAdded,
        sourceParam : 'addToBagFromCartCarousel=' + carouselType,
        department : department,
        cat1 : cat1,
        fullPdpUrl : fullPdpUrl,
        currency : currency,
        color : color,
    })
}
function addToBagFromShoppingBagWithObject(obj) {
    const code = obj.code;
    const size = obj.size;
    const name = obj.name;
    const brand = obj.brand;
    const imageUrl = obj.imageUrl;
    const categoryName = obj.categoryName;
    const brandName = obj.brandName;
    const pdpUrl = obj.pdpUrl;
    const dateAdded = obj.dateAdded;
    const callback = obj.callbacks ? obj.callbacks.success : null;
    const retailPrice = obj.retailPrice;
    const cartCount = parseInt($("#cart_item_count").text(), 10);
    const department = obj.department;
    const cat1 = obj.cat1;
    const fullPdpUrl = obj.fullPdpUrl;
    const currency = obj.currency;
    const color = obj.color;
    window.addProduct(code, size, window.rcProps.shoppingBag.sectionURL, window.rcProps.shoppingBag.sessionID, 1, function() {
        var cartItems = new Array();
        var cartItem = {};
        cartItem.productCode = code;
        cartItem.size = size;
        cartItem.productName = name;
        cartItem.brandName = brand;
        cartItem.images = [imageUrl];
        cartItem.productCategory = categoryName;
        cartItem.brandName = brandName;
        cartItem.url = pdpUrl;
        cartItem.department = department;
        cartItem.cat1 = cat1;
        // cartItem.price = retailPrice;
        cartItems.push(cartItem);

        if(typeof window.insertFacebookAddToCart === 'function'){
            window.insertFacebookAddToCart(code, retailPrice);
        }
        if(typeof insertTiktokAddToCart === "function"){
            insertTiktokAddToCart(code);
        }
        if(typeof window.insertCordialAddToCart === 'function'){
            window.insertCordialAddToCart(cartItems);
        }
        if(typeof window.insertTaboolaAddToCart === 'function') {
            window.insertTaboolaAddToCart("add", code);
        }

        if(typeof brazeAddToCart === 'function') {
            brazeAddToCart('add',
                code, name, size, imageUrl, fullPdpUrl, retailPrice, currency, department, color, brandName, categoryName, cat1);
        }

        if (cartCount === 0) {
            location.reload();  // init PayPal button since adding to empty state
        } else {
            reloadShoppingBag(callback);
        }
    }, false, true, null, dateAdded, obj);
}


//************** the code below are for wishlist carousel, need to switch to main pdp feo js when we update this carousel with new style guide **************//
//the js below are copied from pdp-main.js

window.moveToWishList = function (code, size, $cartItem) {
    if(typeof $cartItem === "undefined"){
        $cartItem = $('#shopbag_tbody').find('tr[data-code="'+code+'"][data-size="'+size+'"]');
    }
    var email = window.rcProps.shoppingBag.email;
    if (!email && !window.rcProps.shoppingBag.canGuestsHaveFavorites) {
        var redirectPage = '/fw/ShoppingBag.jsp' + location.search;
        window.location = '/fw/Login.jsp?page=' + encodeURIComponent(redirectPage);
        return;
    }
    var data = $.param({
        code : code,
        sectionURL : window.rcProps.shoppingBag.sectionURL,
        sessionID : window.rcProps.shoppingBag.sessionID,
        size : size,
        email : email
    });

    $.post("/fw/addToWishList.jsp", data, function() {
        if(typeof $cartItem !== "undefined") {
            $cartItem.find(".js-remove-prod").data('no-notification', true);
            removeProductInternal($cartItem.find(".js-remove-prod"), true);
        }
        if ($('#wishlist-wrapper').length == 0) {
            loadcarousels();
            return;
        }
        const layout = $("#wishlist-wrapper").data('layout');
        const data = $.param({
            gridLayout: layout === 'gridLayout'
        });
        $.get(WISHLIST_MARKUP_ENDPOINT, data, function(rtn){
            $("#wishlist-wrapper").empty().append(rtn);
            reinitializeWishListCarousel();
            $(".remove_wish_list").click(removeWishListItem);

            $.modal({
                open: "item-wishlist-modal",
                triggerOpen: true,
                type: "notification",
            });
        });

        if (typeof window.insertPageTrack === 'function') {
            window.insertPageTrack(null, false, code);
        }
        if (typeof window.insertCordialUpdateWishList === 'function') {
            window.insertCordialUpdateWishList('add', code);
        }

        if (typeof window.gaUpdateWishList === 'function') {
            window.gaUpdateWishList('add',code);
        }
        if(typeof  window.taboolaWishListAction === 'function') {
            window.taboolaWishListAction("add", code);
        }

        if(typeof brazeAddToFavorites === 'function') {
            brazeAddToFavorites('add',
                code,
                $cartItem.data('name'),
                size,
                $cartItem.data('imageurl'),
                $cartItem.data('pdpurl'),
                $cartItem.data('price'),
                $cartItem.data('currency'),
                $cartItem.data('department'),
                $cartItem.data('color'),
                $cartItem.data('brand'),
                $cartItem.data('category'),
                $cartItem.data('cat1')
            );
        }

        var wishlistCountUpdater = new window.WishlistCountUpdater();
        wishlistCountUpdater.updateCount();
    });
}

function bindEvents(){
    $('.js-go-to-referrer').click(function (e) {
        e.preventDefault();
        let target = document.referrer;
        const checkoutPages = ['ShoppingBag', 'ShippingOptions', 'DeliveryOptions', 'PaymentOptions', 'ReviewConfirm'];
        let isCheckout = false;
        if (target) {
            for (let i = 0; i < checkoutPages.length; i++) {
                if (target.indexOf(checkoutPages[i]) > 0) {
                    isCheckout = true;
                    break;
                }
            }
        }
        if (isCheckout && window.rcProps.shoppingBag.defaultReferrer != '') {
            target = window.rcProps.shoppingBag.defaultReferrer;
        }
        window.location = target;
    });

    $('.js-remove-prod').click(function(e){
        e.preventDefault();
        removeProductInternal($(this), false);
    });

    $('.js-shopping-bag__qty').change(function(){
        var wrapper = $('#' + $(this).data('wrapper'));
        var code = wrapper.data('code');
        var size = wrapper.data('size');
        var oldQty = parseInt(wrapper.data('qty'));
        var newQty = parseInt($(this).val());
        if(oldQty == newQty) return;
        clickTracker("edit_quantity", code);
        if(newQty == 0){
            wrapper.find(".js-remove-prod").click();
            return;
        }else{
            if(newQty < oldQty){
                wrapper.data('qty', parseInt(newQty));
                window.removeProduct(code, size, (oldQty - newQty), function(){
                    reloadShoppingBag(function () {
                        $.modal({
                            open: "item-qty-update-modal",
                            triggerOpen: true,
                            type: "notification",
                        });
                    });
                });
            }else{
                wrapper.data('qty', parseInt(newQty));
                var sectionURL = wrapper.data('sectionurl');
                var name = wrapper.data('name');
                var brand = wrapper.data('brand');
                var categoryName = wrapper.data('category');
                var price = wrapper.data('price');
                var currencyCode = wrapper.data('currency');

                updateBag(code, size ,newQty, sectionURL, name, brand, categoryName, price, currencyCode, oldQty, function () {
                    wrapper.data('qty', parseInt(oldQty));
                    wrapper.find('.shopping-bag__qty').val(oldQty);
                });
            }
        }
    });

    $('.js-wishlist-prod').click(function (e) {
        e.preventDefault();
        var $wrapper = $('#' + $(this).data('wrapper'));
        var code = $wrapper.data('code');
        var size = $wrapper.data('size');
        clickTracker("move_to_wishlist", code);
        moveToWishList(code, size, $wrapper);
    });

    $(".js-undo-remove-shopping-item-wrapper").on('click', function () {
        const btn = $(this);
        if (btn.data('movetowishlist')) {
            $.post('/fw/EditWishlist.jsp',
                $.param({
                    code: btn.data('code'),
                    size: btn.data('size'),
                }),
                function () {
                    if (typeof window.reloadWishListCarousel === 'function') {
                        window.reloadWishListCarousel();
                    }
                    addProductToBagAgain(btn);
                });
        } else {
            addProductToBagAgain(btn);
        }
    });

}

function addProductToBagAgain(btn){
    addToBagFromShoppingBagWithObject({
        code: btn.data('code'),
        size: btn.data('size'),
        name: btn.data('name'),
        brand: btn.data('brand'),
        imageUrl: btn.data('imageUrl'),
        categoryName: btn.data('categoryName'),
        brandName: btn.data('brandName'),
        pdpUrl: btn.data('pdpUrl'),
        retailPrice: btn.data('retailPrice'),
        dateAdded: btn.data('dateAdded'),
        serialNumber: btn.data('serial'),
        department: btn.data('department'),
        cat1: btn.data('cat1'),
    });
    logEngagement(
        window.location.href,
        ENGAGEMENT_MODULE,
        'undo_remove',
        {code: btn.data('code')}
    );
}
function loadForwardMultipleQuickView(event, codes, sbsrc, carouselType) {
    event.preventDefault();
    showQuickView(event, codes, sbsrc, carouselType, quickViewDisplayCallBack);
}

function removeProductInternal($this, movedToWishList){
    var wrapper = $('#' + $this.data('wrapper'));
    var code = wrapper.data('code');
    var size = wrapper.data('size');
    var serial = wrapper.data('serial');
    clickTracker("remove_item", code);
    var noNotification =$this.data('no-notification');
    var focusIndex;
    var itemRemovedModal = document.getElementById('item-removed-modal'); // test id=931, group A
    if($this.parents('.item_row').next().is(':visible')) {
        focusIndex = $this.parents('.item_row').index();
    } else {
        focusIndex = $this.parents('.item_row').parent().children('tr:visible:first').index();
    }
    let removedItemIndex = -1;
    removedItemIndex = $this.data('wrapper').substring("item-".length);
    if (typeof window.removeProduct === 'function') {
        window.removeProduct(code, size, null, function (obj) {
            reloadShoppingBag(function () {
                if (!noNotification) {
                    if (itemRemovedModal) { // show notification if test id=931, group A
                        $.modal({
                            open: 'item-removed-modal',
                            triggerOpen: true,
                            onClose: function () {
                                if (focusIndex !== undefined) {
                                    $('.shopbag_table .item_row').eq(focusIndex).find('.image_wrap a').focus();
                                }
                            }
                        });
                    }
                }
            }, removedItemIndex);
        }, serial, movedToWishList, wrapper);
    }
}


function quickViewDisplayCallBack(carouselType, $triggerTarget)
{
    //attach color box close behavior
    $('.pop_cancel').click(
        $.modal.close
    );

    //disable links on images
    $(".qvImage").click(function(event) {
            if (event) {
                (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
            }
        }
    );

    $("#buy-now-btn-div").hide();

    $("#size_and_fit_link").click(function (event) {
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
        //var url = $("#size_and_fit_link").data("url");
        //var measurements = $("#size_and_fit_link").data("measurements");
        showSizeGuidePopup();
    });

    $("#add-to-bag-btn").click(function(event) {
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;


        //get selected size
        var size =$('#size-select option:selected').val();
        if ($("#product_info").data("onesize"))
        {
            size = 'all';
        }
        //get selected code
        var code = $("#product_info").data("code");
        //update add to bag pop up's size
        $("#item-added-size").text(size);

        var btn = $(this);
        if(btn.hasClass("special-order")){
            //do special-order
            $("#cant-find-size-link").click();
        }
        else if (btn.hasClass("oos"))
        {
            //do nothing.
        }
        else {
            //do add to bag
            addToBag(undefined, undefined, carouselType, $triggerTarget);
        }
    });


    //init size selector
    $("#size-select").change(handleSizeSelection);

    //special order
    $("#cant-find-size-link").click(showNotifyMePopup);

    //wishlist
    $("#add-to-wishlist-link").hide();

    //initialize slideshow
    $(".productSelector").click(
        handleProductSelection
    );
}

function handleSizeSelection(event)
{
    //supress default event
    if(event){
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
    }
    $("#buy-now-btn-div").hide();

    //handle size related tasks
    var selectedSize = $("#size-select option:selected");
    //set estimaed delivery date
    $("#est-span").text(selectedSize.data("est-delivery-date"));

    var addToCartButton = $("#add-to-bag-btn");
    var oneLeftDiv = $("#one-left-div");
    var estimatedDelivery = $("#est-p");
    $("#select-size-error").hide();

    if (selectedSize.data("is-oos"))
    {
        oneLeftDiv.hide();
        estimatedDelivery.hide();
        if (selectedSize.data("isOnSale") || !selectedSize.data("eligibleForSpecialOrder")) {
            addToCartButton.text("Notify Me");
        } else {
            addToCartButton.text("Notify Me / Special Order");
        }
        addToCartButton.addClass("special-order")
    }
    else if (selectedSize.data("is-preorder"))
    {
        estimatedDelivery.show();
        oneLeftDiv.hide();
        addToCartButton.text("Preorder");
        addToCartButton.addClass("preorder")
    }
    else{
        addToCartButton.removeClass("special-order").removeClass("preorder").removeClass("oos");
        estimatedDelivery.show();
        //
        if (selectedSize.data("is-one-left"))
        {
            oneLeftDiv.show();
        }
        else{
            oneLeftDiv.hide();
        }
        addToCartButton.text("Add To Bag");
    }
}

function handleProductSelection(event)
{
    if(event){
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
    }

    var data = $(this).data();
    var code = data.code;
    //change product info
    $("#product_info").data("code",data.code);
    $("#product_info").data("onesize",data.oneSize);

    //hide only one in stock message
    $("#one-left-div").hide();

    //find object that has this code
    for (var i = 0; i<productDataSet.length;i++)
    {
        var selectedDisplayProductDataObject = productDataSet[i].currentProductData;
        if (data.code==selectedDisplayProductDataObject.code)
        {
            updateQuickviewForCode(selectedDisplayProductDataObject, productDataSet[i])
            break;
        }
    }

    //handle quickview
    $(".qvImage").click(function(event) {
            if (event) {
                (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
            }
        }
    );
    //add recent viewed track
    addToRecentViewed(code);

}

function updateQuickviewForCode(data, dataSet)
{
    //update title
    $("#qvName").text(data.name);

    //update brand
    $("#qvBrand").text(data.brand);

    //update price
    $("#discountPrice").text(data.priceDisplay);
    $("#qvPrice").text(data.retailPriceDisplay);
    //update sale price if item is on sale
    if (data.onSale)
    {
        $("#discountPrice").show();
        $("#priceBox").addClass("sale");
    }
    else{
        $("#discountPrice").hide();
        $("#priceBox").removeClass("sale");
    }

    //estimated delivery date
    $("#est-span").text(data.estimatedDeliveryDate);
    $("#est-span").data("date",data.estimatedDeliveryDate);

    //update images
    //remove current main images
    $(".qvImage").remove();

    for(var imageCounter = 0;imageCounter<data.images.length; imageCounter++)
    {
        var imageString = "<a href='#' class='cycle-slide cycle-sentinel qvImage'><img alt='"+data.name+"' src='"+data.images[imageCounter]+"'></a>";
        $("#qvImageContainer").append(imageString);
    }

    //update color
    $("#qvColor").text(data.color);

    //update sizes
    //remove current sizes
    $("#size-select").find('option').remove();
    //append sizes for selected item
    $("#size-select").append("<option value=''>Select Size</option>");
    for(var i = 0;i<data.sizes.length; i++)
    {
        var sizeLabelString = data.sizes[i].size;
        var qtyStatus=data.sizes[i].quantityStatus;
        if (qtyStatus && qtyStatus!="")
        {
            //show inline qty status for sold out only
            if (qtyStatus=="Sold Out")
            {
                sizeLabelString += " - OUT OF STOCK";
            }

        }
        var onlyOneFlag = data.sizes[i].quantity==1?true:false;
        var estDelDate = data.estimatedDeliveryDate;
        if (data.sizes[i].preorderDate)
        {
            estDelDate = data.sizes[i].preorderDate;
        }

        //add options
        $("#size-select").append("<option value='"+data.sizes[i].size +"'" +
            " data-is-preorder='" +data.sizes[i].preorder+"'"+
            " data-is-oos='" +data.sizes[i].outOfStock+"'"+
            " data-is-one-left='" +onlyOneFlag+"'"+
            " data-eligible-for-special-order='" +data.sizes[i].eligibleForSpecialOrder+"'"+
            " data-est-delivery-date='"+estDelDate + "'" +
            " data-is-on-sale='" + data.onSale+ "'" +
            ">"+sizeLabelString+"</option>");
    }

    if (data.isOOS)
    {
        //sizes
        $("#size-select").hide();
        $("#qvSizeLabel").hide();
        $("#one-size-div").hide();

        $("#sold-out-div").show();
        if(data.onSale){
            $("#add-to-bag-btn").text("Notify Me");
            $("#add-to-bag-btn").addClass("special-order")

        }else{
            $("#add-to-bag-btn").text("Notify Me / Special Order");
            $("#add-to-bag-btn").addClass("special-order")
        }

    }
    else if (data.isOneSize)
    {
        $("#size-select").hide();
        $("#sold-out-div").hide();
        $(".select_dropdown").hide();

        $("#qvSizeLabel").show();
        $("#one-size-div").show();

        $("#add-to-bag-btn").text("Add To Bag");
    }
    else{
        //preorder or in stock
        if (data.isAllPreOrder)
        {
            $("#add-to-bag-btn").text("Preorder");
        }
        else{
            $("#add-to-bag-btn").text("Add To Bag");
        }

        //last one in stock
        $("#one-size-div").hide();
        $("#sold-out-div").hide();

        $(".select_dropdown").show();
        $("#size-select").show();
        $("#qvSizeLabel").show();
    }

    //size and fit links
    if (data.sizeGuide && data.sizeGuide!="" && data.sizeGuide!="NONE")
    {
        //show span
        $("#qvSizeAndFitSpan").show();
        //update size guide data
        $('#size_and_fit_link').data("url",data.sizeGuideUrl);
        $('#size_and_fit_link').data("measurements",data.measurementDescription);
        $('#size_and_fit_link').data("measuretable",data.measurements);
        $('#size_and_fit_link').data("bullets",data.bulletDescription.join());
    }
    else
    {
        $("#qvSizeAndFitSpan").hide();
    }

    //update view full details
    $("#displayLink").prop("href",data.productDisplayLink);

    //update brands link
    $("#qvBrand").prop("href",data.brandLink);

    //update color div with code
    $(".qvOneColor").data("code",data.code);
    //update add to cart button data with code
    $("#add-to-bag-btn").data("code",data.code);
    $("#cant-find-size-link").data("code",data.code);

    //show or hide final sale banner
    if (data.finalSale)
    {
        $("#finalsaleDiv").show();
    }
    else
    {
        $("#finalsaleDiv").hide();
    }

    //update add to cart popup
    $("#addToBagLink").prop("href",data.productDisplayLink);
    $("#addToBagImage").prop("src",data.images[0]);
    $("#addToBagBrand").text(data.brand);
    $("#addToBagTitle").text(data.name);
    $("#addToBagPrice").text("$"+data.retailPrice);
    $("#addToBagDiscountPrice").text("$"+data.price);
    $("#addToBagColor").text(data.color);

    //update special order elements
    if (data.isSpecialOrderVisible && !data.onSale && !data.isOOS)
    {
        $("#cant-find-size-span").show();
    }
    else{
        $("#cant-find-size-span").hide();
    }

    //init can't find size or special order flag
    $("#cant-find-size-link").data("showSpecialOrder", data.isSpecialOrderVisible);
    $("#cant-find-size-link").data("showBackInStock", data.isBackInStockVisible);
    if(data.onSale){
        $("#cant-find-size-link").data("showSpecialOrder", false);
    }
    insertPageTrackForMultiItemQuickView($("#urlForPageTrack").val(), data.code);
}
window.addToBag = function (size, code, carouselType, $triggerTarget) {
    if(size == undefined) {
        size = getSelectedSize(true);
    }

    var btn;
    if($("#add-to-bag-btn").is(":visible")){
        btn = $("#add-to-bag-btn");
    }else if($("#add-to-bag-btn-modal").is(":visible")){
        btn = $("#add-to-bag-btn-modal");
    }else if($("#add-to-bag-btn-so-modal").is(":visible")){
        btn = $("#add-to-bag-btn-so-modal");
    }else{
        return ;
    }
    if(code == undefined) {
        code = btn.data("code");
    }
    var sectionURL = btn.data("sectionurl");
    var sessionID = btn.data("sessionid");
    if( size == '' || size == undefined || !code) return;
    const cartCount = parseInt($("#cart_item_count").text(), 10);
    let logEngagementModule = 'wish_list';
    if (carouselType === 'recently_viewed') {
        logEngagementModule = 'recently_viewed';
    }

    window.addProduct(code, size, sectionURL, sessionID, 1, function(){
        logEngagement(window.location.href, logEngagementModule, "move_to_bag");
        if (cartCount === 0) {
            location.reload();  // init PayPal button since adding to empty state
        } else {
            reloadShoppingBag(function () {
                openAddToBagNotificationModal(carouselType, $triggerTarget);
                if (carouselType === 'recently_viewed') {
                    loadcarousels();
                }
            });
        }
    }, false, false, null, null, {sourceParam : 'addToBagFromCartCarousel=' + carouselType});
};

function addToBag(size, code, carouselType, $triggerTarget){
    window.addToBag(size, code, carouselType, $triggerTarget);
}
function getSelectedSize(showWarning){
    var size;
    if($("#one-size-div:visible").length > 0 ||
        $("#product_info").data("onesize")) {
        size = 'all';
    }else{
        if($.trim($("#size-select option:selected").val()) ){
            size = $.trim($("#size-select option:selected").val());
        }
    }
    if(!size &&  showWarning){
        //no size selected
        $("#select-size-error").slideDown();
        return false;
    }else{
        $("#select-size-error").hide();
    }
    return size;
}
function showSpecialOrderPopup(event){
    if(event){
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
    }

    var data = $.param({
        code : $(this).data("code"),
        dept : $(this).data("dept"),
        sectionURL : $(this).data("sectionurl"),
        sessionID : $(this).data("sessionid"),
        size : getSelectedSize(false)
    });

    var initSpecialOrderPopup = function(){
        //bind events here
        $("#special-order-sizes button").click(clickSpecialOrderSize);

        $("#special-order-btn").click(submitSpecialOrderOrNotifyMe);

        $(".close-popup").click(closePopup);
    };

    $.modal({
        url : "/fw/dialog/SpecialOrder.jsp",
        data : data,
        scrolling : false,
        triggerOpen:true,
        type: 'small',
        onComplete : function(){
            if(typeof initSpecialOrderPopup === 'function'){
                initSpecialOrderPopup();
            }
        }
    });
}

var backInStockUtils = (function(){
    function submitNotifyMe(object, notifyMeFeatureFromSpecialOrderPage){
        var data = {};
        var thankyouDivToShow='';
        var email='';
        //if notifyme feature is being submitted from special order page, skip validation and
        //fetch size and email from different elements
        if (notifyMeFeatureFromSpecialOrderPage==false) {
            email=$("#special-order-email").val();
            data = $.param({
                size : $("#special-order-sizes").find(".js-size-button.push-button--active").data("size"),
                email : email,
                code : object.data("code"),
                fw : true
            });
            thankyouDivToShow='#thank-you-div-notifyme';
        }
        else{
            if (!validateInput())
                return;
            email = $("#email-input").val();
            data = $.param({
                size : $("#cant-find-size-ul").find(".js-size-button.push-button--active").data("size"),
                email : email,
                code : $(this).data("code"),
                fw : true
            });
            thankyouDivToShow='#thank-you-div';
        }

        $.post("/r/ajax/SubmitFindSizeInquiry.jsp", data, function(msg){
            var result = $.parseJSON(msg);
            if(result.success){
                $("#thank-you-email").html(email);
                $("#main-div").hide();
                $(thankyouDivToShow).show();
            }else{
                //show error message
            }
        });

    }

    function validateInput(){
        var valid = true;
        if($("#instock-msg").is(":visible")){
            valid = false;
        }
        if(!$("#cant-find-size-ul").find(".js-size-button.push-button--active").length) {
            $("#selectsize-msg").slideDown(600);
            valid = false;
        }else{
            $("#selectsize-msg").hide();
        }
        if(!validateEmail($("#email-input").val())){
            $("#email-input").addClass("errortextbox");
            valid = false;
        }else{
            $("#email-input").removeClass("errortextbox");
        }
        return valid;
    }

    function clickSize(event){
        if(event.preventDefault){
            event.preventDefault();
        }else{
            event.returnValue = false;
        }
        $(this).closest("#cant-find-size-ul").find(".push-button--active").removeClass("push-button--active");
        $(this).addClass("push-button--active");
        $("#selectsize-msg").slideUp();
        const revolveInStock = $(this).data('revolve');
        const inStock = $(this).data("instock");
        $('.js-notification-r-in-stock').hide();
        $('.js-shop-revolve-instock').hide();
        if($(this).data("instock") && !$(this).data("preorder")){
            //instock, not preorder
            $("#instock-msg").slideDown(600);
            // $("#notify-me-btn").addClass("disable").prop("disabled", true);
            $(".regular").hide();
            $(".preorder").hide();
            $("#email-input").hide();
            $("#add-to-bag-btn-modal").text('ADD TO BAG');
            $("#add-to-bag-btn-modal").show();
            $("#notify-me-btn").hide();
            var clickedSize = $(this).attr("data-size");
            $('#size-select option[value="'+clickedSize+'"]').prop('selected', true);
        }else if($(this).data("preorder")){
            //preorder
            $(".preorder").show();
            $(".regular").hide();
            $("#instock-msg").slideUp();
            $("#email-input").hide();
            $("#add-to-bag-btn-modal").text('PREORDER');
            $("#add-to-bag-btn-modal").show();
            $("#notify-me-btn").hide();
            var clickedSize = $(this).attr("data-size");
            $('#size-select option[value="'+clickedSize+'"]').prop('selected', true);
        } else if (!inStock && revolveInStock) {
            $(".regular").show();
            $(".preorder").hide();
            $("#instock-msg").slideUp();
            $("#email-input").hide();
            $("#add-to-bag-btn-modal").hide();
            $("#notify-me-btn").hide();
            $('.js-notification-r-in-stock').show();
            $('.js-shop-revolve-instock').show();
        } else
        {
            //not pre order not in stock =(out of stock)
            $(".regular").show();
            $(".preorder").hide();
            $("#instock-msg").slideUp();
            $("#email-input").show();
            $("#add-to-bag-btn-modal").hide();
            $("#notify-me-btn").show();
        }
    }

    function emailInputKeyup(){
        var valid = false;
        if(validateEmail($(this).val())){
            $(this).removeClass("errortextbox");
        }
    }

    function validateEmail(emailStr) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(emailStr);
    }
    return {
        submitNotifyMe : submitNotifyMe,
        clickSize : clickSize,
        emailInputKeyup : emailInputKeyup
    };

})();


//handles all notify me requests. can't find your size and special order inquiry both.
//depending on the item quantity type(preorder, out of stock, instock, or combination), price type(sale/regular),
//and number of item sizes(mutlsize, one size)
function showNotifyMePopup(event){
    if(event){
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
    }

    var data = $.param({
        code : $(this).data("code"),
        dept : $(this).data("dept"),
        sectionURL : $(this).data("sectionurl"),
        sessionID : $(this).data("sessionid"),
        showSpecialOrder : $(this).data("showSpecialOrder"),
        showBackInStock: $(this).data("showBackInStock"),
        size : getSelectedSize(false)
    });

    //determine which page to call.
    var showSpecialOrderOnly = false;

    if ($(this).data("showSpecialOrder")===true && $(this).data("showBackInStock")===false) {
        showSpecialOrderOnly = true;
    }

    if (showSpecialOrderOnly==true){

        var data = $.param({
            code : $(this).data("code"),
            dept : $(this).data("dept"),
            sectionURL : $(this).data("sectionurl"),
            sessionID : $(this).data("sessionid"),
            size : getSelectedSize(false)
        });

        var initSpecialOrderPopup = function(){
            $("#special-order-sizes button").click(clickSpecialOrderSize);

            $("#special-order-btn").click(submitSpecialOrderOrNotifyMe);

            $(".close-popup").click(closePopup);
        };

        $.modal({
            url : "/fw/dialog/SpecialOrder.jsp",
            data : data,
            triggerOpen:true,
            scrolling : false,
            type: 'small',
            onComplete : function(){
                if(typeof initSpecialOrderPopup === 'function'){
                    initSpecialOrderPopup();
                }
            }
        });
    }
    else
    {
        function initPopup(){

            $("#cant-find-size-ul a").click(backInStockUtils.clickSize);

            $("#notify-me-btn").click(backInStockUtils.submitNotifyMe);

            $(".close-popup").click(closePopup);

            $("#email-input").keyup(backInStockUtils.emailInputKeyup);

            $("#popup-show-special-order").click(showSpecialOrderPopup);
        }

        $.modal({
            url : "/fw/dialog/CantFindYourSize.jsp",
            data : data,
            triggerOpen:true,
            scrolling : false,
            type: 'small',
            onComplete : function(){
                initPopup();
                $("ul#cant-find-size-ul .push-button--active").click();
            }
        });
    }


}



function showSizeGuidePopup()
{
    var data = $.param({
        "measurements" : $("#size_and_fit_link").data("measurements"),
        "measuretable" : $("#size_and_fit_link").data("measuretable"),
        "international" : $("#size_and_fit_link").data("international"),
        "bullets" : $("#size_and_fit_link").data("bullets")
    });
    $.modal({
        url : $("#size_and_fit_link").data("url"),
        data : data,
        triggerOpen: true,
        onComplete : function(){
            $(".sizeguide_measurement").click(
                convertSize
            );
        }
    });
}

function closePopup(event){
    if(event){
        (event.preventDefault) ? event.preventDefault() : event.returnValue = false;
    }
}

function enableSpecialOrder(){
    var btn = $("#special-order-btn");
    btn.prop("disabled", false).css("opacity","1");

}

function disableSpecialOrder(){
    var btn = $("#special-order-btn");
    btn.prop("disabled", true).css("opacity","0.5");
}

function enableNotifyMe(){
    $("#notEligibleForSpecialOrder").show();
    $("#is-place-order-div").hide();
    $("#special-order-comment").hide();
    $("#special-order-btn").val("Notify Me");
}

function disableNotifyMe(){
    $("#notEligibleForSpecialOrder").hide();
    $("#is-place-order-div").show();
    $("#special-order-comment").show();
    $("#special-order-btn").val("Submit Special Order");
}

function clickSpecialOrderSize(event){
    (event.preventDefault) ? event.preventDefault() : event.returnValue = false;

    $(this).closest("#special-order-sizes").find('.action-button--active').removeClass("action-button--active");
    $(this).addClass("action-button--active");
    $("#so-select-size-error").removeClass("u-error");
    var size = $(this).attr("data-size");
    var canSpecialOrder = $(this).attr("data-can-special-order");
    $("#regular_so_msg").show();
    const revolveInStock = $(this).data('revolve');
    const inStock = $(this).data("isInstock");
    $('.js-notification-r-in-stock').hide();
    $('.js-shop-revolve-instock').hide();
    $(".spl-ord-works").show();

    if($(this).data("isInstock") || $(this).data("preorder")){
        $("#regular_so_msg").hide();
        //disable button
        if ($(this).data("preorder"))
        {
            $("#instock-msg").text("Currently available for preorder");
            $("#add-to-bag-btn-so-modal").text('PREORDER');
        }
        else{
            $("#instock-msg").text("Currently in stock");
            $("#add-to-bag-btn-so-modal").text('ADD TO BAG');
        }
        var clickedSize = $(this).attr("data-size");
        $('#size-select option[value="'+clickedSize+'"]').prop('selected', true);
        $("#add-to-bag-btn-so-modal").show();
        $("#specialOrderForm").hide();

        $("#instock-msg").slideDown(600);
        disableSpecialOrder();
        disableNotifyMe();
    } else if (!inStock && revolveInStock) {
        $("#instock-msg").hide();
        $("#add-to-bag-btn-so-modal").hide();
        disableNotifyMe();
        disableSpecialOrder();
        $(".spl-ord-works").hide();
        $('.js-notification-r-in-stock').show();
        $('.js-shop-revolve-instock').show();
    }else if (canSpecialOrder=="false")
    {
        $("#add-to-bag-btn-so-modal").hide();
        $("#specialOrderForm").show();
        enableSpecialOrder();
        enableNotifyMe();
        $("#instock-msg").hide();
    }
    else{
        $("#add-to-bag-btn-so-modal").hide();
        $("#specialOrderForm").show();
        //enable button
        $("#instock-msg").slideUp(600);
        enableSpecialOrder();
        disableNotifyMe();
    }


}

function submitSpecialOrderOrNotifyMe()
{
    if ($("#special-order-btn").val()=="Submit Special Order")
        submitSpecialOrder.apply(this);
    else if($("#special-order-btn").val()=="Notify Me")
        backInStockUtils.submitNotifyMe($("#special-order-btn"),false);
}

function submitSpecialOrder(){
    var size = $("#special-order-sizes .js-size-button.action-button--active").attr("data-size");
    if(!size){
        //add pleace select size alert
        $("#so-select-size-error").addClass("u-error");
        return ;
    }else{
        //remove select size alert
        $("#so-select-size-error").removeClass("u-error");
    }
    var email = $("#special-order-email").val();
    if(!email) {
        $("#special-order-email").addClass("errortextbox");
        return;
    }else{
        $("#special-order-email").removeClass("errortextbox");
    }

    var data = $.param({
        SOProductCode: $(this).data("code"),
        SOSectionURL: $(this).data("sectionurl"),
        SOSessionID: $(this).data("sessionid"),
        SOSize: size,
        SOUserEmail: email,
        SOAutoOrder: $("#is-place-order-div").find("input:checked").val(),
        SOComment: $("#special-order-comment").val()
    });
    $.post("/fw/SubmitSpecialOrderInquiry.jsp", data, function(){
        showConfirmPopup();
    });
}

function showConfirmPopup(){
    $("#main-div").hide();
    $("#thank-you-div").show();
}

    function convertSize()
    {
        $(".sizeguide_measurement").removeClass("active");
        $(this).addClass("active");

        //console.log($(this).text());
        if ($(this).text()=="IN")
        {
            $(".sizeToConvertInch").show();
            $(".sizeToConvertCM").hide();
        }
        else{
            $(".sizeToConvertCM").show();
            $(".sizeToConvertInch").hide();
        }
    }

window.enableSpecialOrder = function(){
    enableSpecialOrder();

};

window.disableSpecialOrder = function(){
    disableSpecialOrder();
};

window.enableNotifyMe = function(){
    enableNotifyMe();
};

window.disableNotifyMe = function(){
    disableNotifyMe();
};


$(function () {
    showBagSyncNotifications();
    $('.js-select-size').sizeSelectionModal();

    setupViewShippingOptions();

    $(".remove_wish_list").click(removeWishListItem);

    $('.close-popup').click(closePopup);

    bindEvents();

    window.loadForwardMultipleQuickView = loadForwardMultipleQuickView;
    window.addToBagFromWishList = addToBagFromWishList;
    window.addToBagFromCarouselItem = addToBagFromCarouselItem;

    renderCartSocialProof($('.item_row').toArray().map((el) => $(el).data('code')));
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/shoppingbag/index.js